import { SxProps, Theme } from '@mui/material';

export const accordianRootStyles: SxProps<Theme> = {
  margin: 0,
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
};
export const indicatorStyles: SxProps<Theme> = {
  marginLeft: '5%',
  backgroundColor: '#DDDDDD',
  color: 'white',
};
